import { fg } from '@atlassian/jira-feature-gating';

const AutonomousAgentsInSpaceRelayProvider = {
	get(): boolean {
		return fg('aa-296_fe_rovo_agents_can_take_actions');
	},
};

export default AutonomousAgentsInSpaceRelayProvider;
